export const QUICK_ACTION_FIELD_COL_CLASS = 'w-[9.5rem] shrink-0';
export const QUICK_ACTION_FIELD_COL_WIDE_CLASS = 'w-[11rem] shrink-0';
export const QUICK_ACTION_PROPOSED_PRICE_COL_CLASS = 'w-[12.5rem] shrink-0';

export const QUICK_ACTION_APPROVE_FIELDS_WIDTH_CLASS =
    'w-[43.25rem] max-w-full';

export const quickActionFormContentWidthClassName =
    'w-[36rem] max-w-full shrink-0';

export const quickActionFormFieldsShellClassName =
    'max-w-full min-w-0 self-start overflow-x-auto';

export const quickActionFormFieldsBlockClassName =
    'inline-block min-w-0 align-top';

export const quickActionFormFieldsRowClassName =
    'flex flex-nowrap items-start gap-x-3 pb-1';

export const quickActionFormFieldClassName = 'w-[14rem] max-w-full shrink-0';

export const quickActionFormFieldFullWidthClassName =
    quickActionFormContentWidthClassName;

export const quickActionFormFieldNarrowClassName = 'min-w-0 flex-1 shrink-0';

export const quickActionFormNotesClassName =
    quickActionFormContentWidthClassName;

export const quickActionFormMarginCardClassName = 'w-full max-w-full shrink-0';

export const quickActionFormStackClassName =
    'flex w-full max-w-full flex-col items-start gap-4 self-start';

export const quickActionFormPairRowClassName =
    'flex w-full max-w-full flex-nowrap items-start gap-x-3';
